import React from 'react';


export enum CheckboxSize  {
    NORMAL              = 'normal',
    NORMAL_13           = 'normal-13',
    NORMAL_14           = 'normal-14',
    SMALL               = 'small',
}

export enum CheckboxType  {
    DEFAULT             = 'default',
    FULL_COLORED        = 'full-colored',
    FILLED              = 'filled',
}
type Props = {
    size?               : CheckboxSize
    type?               : CheckboxType
    isChecked?          : boolean
    disabled?           : boolean

    onClick?            : callback
    onDisabledClick?    : callback

    className?          : string
}


export default function CheckBox(props: Props) {

    const onClick = (e:React.SyntheticEvent) => {
        if (!props.disabled && props.onClick) {
            e.preventDefault();
            e.stopPropagation();
            props.onClick(!props.isChecked,e);
        } else if (props.disabled && props.onDisabledClick) {
            props.onDisabledClick(props.isChecked,e);
        }
    }

    const type = props.type || CheckboxType.DEFAULT
    const size = props.size || CheckboxSize.NORMAL;

    const classes = Classes('gd-cb i5-checkbox-ok', size, type+"-type", props.className, {
        selected: props.isChecked,
        disabled: props.disabled
    });

    return <div className={classes} onClick={onClick}/>;
}

//TODO TSX version
// import React from 'react';
//
//

//
// export default class Checkbox extends React.Component<Props> {
//
//     constructor(props: Props) {
//         super(props);
//
//         if (props.size === undefined) {
//             props.size = checkboxSize.NORMAL;
//         }
//
//         if (props.type === undefined) {
//             props.type = checkboxType.DEFAULT;
//         }
//
//         if (props.isChecked === undefined) {
//             props.isChecked = false;
//         }
//
//         if (props.disabled === undefined) {
//             props.disabled = false;
//         }
//     }
//
//     onClick = (e:React.SyntheticEvent) => {
//         if (!this.props.disabled && this.props.onClick) {
//             e.preventDefault();
//             e.stopPropagation();
//             this.props.onClick(!this.props.isChecked,e);
//         } else if (this.props.disabled && this.props.onDisabledClick) {
//             this.props.onDisabledClick(this.props.isChecked,e);
//         }
//     };
//
//     render() {
//         const classes = Classes('gd-cb i5-checkbox-ok', this.props.size, this.props.type+"-type", this.props.className, {
//             selected: this.props.isChecked,
//             disabled: this.props.disabled
//         });
//
//         return <div className={classes} onClick={this.onClick}/>;
//     }
// }

